export enum NotificationTypesEnum {
  DESTINATION_ACCOUNT = 'DESTINATION_ACCOUNT',
  TRANSACTION = 'TRANSACTION',
  KYC = 'KYC',
}
